import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { CUSTOMARIUS } from "../../assets";
import { useNavigate } from "react-router-dom";
import ButtonV2 from "../../shared/components/buttonV2";

function PublicationDetails() {
  const navigate = useNavigate();
  return (
    <LandingPageLayout
      title={<>Publications</>}
      currentLink="Publications"
      subLink="Customarius"
    >
      <div className="w-full flex items-center justify-center py-8 sm:py-10 px-4 sm:px-8 lg:px-32 bg-[#F7F7F7]">
        <div className="bg-white p-3 sm:p-4 lg:p-2 rounded-xl shadow-boxShadow flex flex-col lg:flex-row items-center lg:items-start gap-4 sm:gap-5 w-full max-w-4xl">
          <img
            src={CUSTOMARIUS}
            className="w-full max-w-[280px] sm:max-w-[320px] lg:w-[340px] h-auto lg:h-[491px] object-contain"
            alt="Customarius Publication"
          />
          <div className="flex flex-col gap-y-4 sm:gap-y-5 w-full lg:w-auto">
            <span className="text-xl sm:text-2xl font-semibold text-primary-300">
              Customarius
            </span>
            <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
              Customarius is a quarterly publication of the Enugu State
              Customary Court of Appeal, dedicated to preserving our customs and
              traditions. The March–June 2025 edition (Volume 8, Issue 8)
              features the theme "A New Nigeria is Judiciously Possible!" and
              highlights key developments within the judiciary, including the
              appointment of a new Deputy Chief Registrar and Director of
              Administration, the President's call urging lawyers to keep their
              focus on the courts, and the periodic training programs for staff
              of the Customary Court of Appeal, Enugu State.
            </span>
            <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
              In addition to these major stories, this issue also provides
              enriching sections such as health tips, jokes, cartoons, and
              proverbs, making it both informative and engaging for readers.
              Customarius continues to reflect the commitment of the Enugu State
              Customary Court of Appeal to justice, transparency, and the
              preservation of cultural heritage.
            </span>
            <div className="w-full lg:w-[400px] bg-[#117D060D] flex flex-col items-start gap-y-3 p-3 rounded-xl">
              <div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-y-1 sm:gap-y-0">
                <span className="text-xs sm:text-sm font-medium text-gray-regular">
                  Publisher:
                </span>
                <span className="text-xs sm:text-sm font-semibold text-primary">
                  Enugu State Customary Court of Appeal
                </span>
              </div>
              <div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-y-1 sm:gap-y-0">
                <span className="text-xs sm:text-sm font-medium text-gray-regular">
                  Publisher:
                </span>
                <span className="text-xs sm:text-sm font-semibold text-primary">
                  Customerium - Volume 8
                </span>
              </div>
            </div>
            <ButtonV2
              title="Click to purchase"
              handleClick={() => {}}
              btnStyle="px-6 sm:px-8 py-2 sm:py-3 bg-globalGreen w-fit flex self-start rounded-full"
              textStyle="text-white font-medium text-sm sm:text-[16px]"
            />
          </div>
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default PublicationDetails;
